import { render, staticRenderFns } from "./RegistrySentToday.vue?vue&type=template&id=70b21d1d&"
import script from "./RegistrySentToday.vue?vue&type=script&lang=js&"
export * from "./RegistrySentToday.vue?vue&type=script&lang=js&"
import style0 from "./RegistrySentToday.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports